<template>
    <div class="loading d-flex">
        <div class="loading-wrapper">
            <lottie :options="defaultOptions" :height="400" :width="500"/>
        </div>
    </div>
</template>

<script>
import Lottie from "vue-lottie";
import animationData from '../assets/animations/loading2-order.json';
export default {
    name: "CheckLoading",
        components:{
        Lottie
    },
    data() {
        return {
            defaultOptions: { animationData: animationData, loop: true },
        }
    },
}
</script>
<style>
    .loading{
        background-color: rgba(255, 255, 255);
        z-index: 100;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        position: fixed;
        margin: 0;
        align-items: center;
        justify-content: center;
    }
    .loading-wrapper {
        height: 100vh;
        width: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
}
</style>